/**
 * Check if a string starts with some other string or array of strings
 * @param {string} string: String to check against
 * @param {string} slices: String or array of strings to check
 * @returns {boolean} string starts with any of the slices
 */
export function startswith(string, slices) {
    let substrings = slices;

    if (!Array.isArray(substrings)) {
        substrings = [substrings];
    }

    for (let i = 0; i < substrings.length; i++) {
        if (string.indexOf(substrings[i]) === 0) {
            return true;
        }
    }

    return false;
}
